import React, {useContext, useMemo} from 'react';
import {PlayerContext} from "../../../shared/contexts/playerContext";
import dayjs from "dayjs";
import LogTemplate from "../../logs/LogTemplate";
import {getPlazaPointLogColumns} from "../../logs/columns/plazaPointLogColumns";

const PlayerPlazaPointLog = () => {
    const { playerData } = useContext(PlayerContext);

    const defaultSearchParams = {
        begin: dayjs().subtract(3, 'month').startOf('day').unix(),
        end: dayjs().endOf('day').unix(),
        pid: playerData.pid,
        logType: 'RQPlazaPointLog',
        isUnix: true
    };

    const columns = useMemo(() => getPlazaPointLogColumns(), []);

    return (
        <div>
            <LogTemplate
                columns={columns}
                defaultSearchParams={defaultSearchParams}
                routerUrl={'/logs/operation'}
                logName={'PlazaPointLog'}
                log={'operation'}
            />
        </div>
    );
};

export default PlayerPlazaPointLog;
